import {
  AfterViewInit,
  Component,
  EventEmitter,
  inject,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { PojavniOblik } from '@app/shared/models/pojavni-oblik';
import {
  Item,
  ItemInfo,
  ItemViewProviderDirective,
  ListView,
  ListViewProviderDirective,
  UIComponents
} from '@ntap/core';
import { first, map, Observable, Subject, takeUntil, tap } from 'rxjs';

@Component({
  selector: 'app-odaberi-pojavni-izlucivanje',
  templateUrl: './odabir-pojavnog-izlucivanje.html'
})
export class SelectPojavniIzlucivanjeComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Output()
  itemSelected = new EventEmitter<PojavniOblik[]>();

  @ViewChild(ListViewProviderDirective)
  listViewProvider: ListViewProviderDirective<ListView>;

  private itemViewProvider = inject(ItemViewProviderDirective);

  INIT_COMP_ID = UIComponents.LISTVIEW;
  currentViewName: string;
  currentViewState: object | null = null;
  currentViewStateFilter: object = {};
  currentViewClass: string;

  disabled$: Observable<boolean>;

  private selectedItems$: Observable<Item[] | null>;
  private destroy$ = new Subject();

  ngOnInit(): void {
    this.currentViewName = 'izlucivanje_pojavni_oblici_pretraga';
    this.currentViewState = {};
    this.itemViewProvider.item$
      .pipe(
        tap((parent) => {
          this.currentViewState = { $parentId: new ItemInfo(parent).id };
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();

    this.currentViewStateFilter = {};
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  public ngAfterViewInit(): void {
    this.selectedItems$ = this.listViewProvider.selectedItems$;
    this.disabled$ = this.selectedItems$.pipe(map((i) => !i || i.length == 0));
  }

  public selectItem() {
    this.selectedItems$
      .pipe(
        first(),
        tap((items) => {
          if (!!items && items.length > 0) {
            this.itemSelected.next(items as PojavniOblik[]);
          }
        })
      )
      .subscribe();
  }
}
